import {TAB_WIDTH} from '../wml/constants'

export class FileBuilder {
    private buf: string[] = []
    private indentLevel = 0

    public indent() {
        this.indentLevel++
    }

    public dedent() {
        this.indentLevel--
    }

    public writeEmptyLine() {
        this.buf.push('')
    }

    public writeLine(line: string = '') {
        this.buf.push(' '.repeat(this.indentLevel * TAB_WIDTH) + line)
    }

    public toString(): string {
        return this.buf.join('\n')
    }
}
